<color-sketch [color]="color" [disableAlpha]="hideOpacity" (onChangeComplete)="onEmitChange($event)"></color-sketch>